import propTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import BusyFlatButton from 'shared/components/BusyFlatButton';
import CloseModalButton from 'shared/components/CloseModalButton';
import * as Colors from 'material-ui/styles/colors';
import { closeDialog } from '../helpers';

const style = {
  title: {
    color: Colors.gray700,
  },
  warnTitle: {
    color: '#fff',
    background: Colors.red900,
    padding: '14px 24px',
  },
  dialogBody: {
    paddingTop: '30px',
    overflowWrap: 'break-word',
  },
  btn: {
    marginLeft: '8px',
  },
  warnBtnText: {
    color: Colors.red900,
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerItem: {
    display: 'inline-block',
  },
  headerFileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 400,
    padding: '0px 0px 0px 7px',
    verticalAlign: 'bottom',
  },
};

export default class DeleteImageDialog extends Component {
  static contextTypes = {
    imageUtils: propTypes.object.isRequired,
  };

  state = {
    error: '',
    busy: false,
  };

  getFileName = image => _.last(_.split(image, '/'));

  getSingleHeaderLabel(fileName) {
    const name = _.join(_.dropRight(_.split(fileName, '.')), '.');
    const extention = _.last(_.split(fileName, '.'));
    return (
      <div>
        <span style={style.headerItem}>Delete forever this </span>
        <span style={{...style.headerItem, ...style.headerFileName}}>{name}</span>
        <span style={style.headerItem}>.{extention} image?</span>
      </div>);
  }

  submit = () => {
    this.setState({ busy: true });
    const { query: { images = [] } } = this.props;
    const currentFolder = _.replace(this.props.currentFolder, /\\/gi, '/');
    let files = [];
    if (_.isArray(images)) {
      files = images.map((image) => this.createDeleteFile(image));
    } else {
      files.push(this.createDeleteFile(images));
    }
    this.context.imageUtils.doDeleteFile({
      path: currentFolder ? `/${currentFolder}/` : '/',
      files
    }, (data) => {
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message, busy: false });
      } else {
        this.setState({ busy: false });
        this.closeDialog();
      }
    });
  };

  createDeleteFile = (image) => ({
    name: this.getFileName(image),
    type: 'Images',
    folder: `${_.join(_.dropRight(_.split(image, '/')), '/')}/`,
  });

  closeDialog = () => {
    if (this.props.integrated) {
      this.props.close();
    } else {
      closeDialog();
    }
  };

  render() {
    const { open, query: { images = [] } } = this.props;
    const single = !_.isArray(images) || _.size(images) === 1;
    const s = single ? '' : 's';
    let fileName = '';
    if (single) {
      fileName = this.getFileName(images);
    }
    const actions = [
      <FlatButton
        label="Cancel"
        disabled={this.state.busy}
        onClick={this.closeDialog}
      />,
      <BusyFlatButton
        labels={[`Yes, delete forever the image${s}`, `Deleting image${s}`]}
        busy={this.state.busy}
        onClick={this.submit}
        style={style.warnBtnText}
        progressColor={Colors.red900}
        keyboardFocused
        primary
      />,
    ];
    return (
      <Dialog
        title={
          <div>
            <CloseModalButton
              onClick={this.closeDialog}
              style={style.closeIcon}
              white
            />
            {!single ? `Delete forever these ${images.length} images?` : this.getSingleHeaderLabel(fileName)}
          </div>
        }
        actions={actions}
        actionsContainerStyle={style.actions}
        modal={false}
        open={open}
        onRequestClose={this.closeDialog}
        titleStyle={style.warnTitle}
        style={{zIndex: 1501}}
      >
        <div style={style.dialogBody}>
          <span style={{ wordBreak: 'break-all'}}>
            {single ? `This "${fileName}"` : `These ${images.length}`}
          </span> image{single ? '' : 's' } will be permanently deleted from your account.<br/>
          (but if you added it to a listing or template, it will still be there)
        </div>
      </Dialog>
    );
  }
}

DeleteImageDialog.propTypes = {
  open: propTypes.bool,
};